import React, { useEffect, useState } from 'react';

import { Grid, LinearProgress, Link, makeStyles, Typography } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import ErrorIcon from '@material-ui/icons/Error';
import queryString from 'query-string';
import { useLocation, useParams } from 'react-router-dom';

import useBlocRefHook from '../../utils/useBlocRef.hook';

const useStyles = makeStyles(() => {
  return {
    container: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '95vh',
      justifyContent: 'center',
      padding: 50,
      width: '100%',
    },
    item: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      padding: 5,
      width: '50%',
    },
  };
});

export default () => {
  const classes = useStyles();
  const { search } = useLocation();
  const blocRef = useBlocRefHook('downloadBloc');
  const [isLoading, setIsLoading] = useState(true);
  const [downloadLink, setDownloadLink] = useState();
  const { resourceId } = useParams();
  const { token } = queryString.parse(search);

  useEffect(() => {
    if (!token) return null;
    blocRef.current.getDownloadLink(resourceId, token).then();
    const subscription = blocRef.current.isLoading$.subscribe(setIsLoading);
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceId, token]);

  useEffect(() => {
    const subscription = blocRef.current.downloadLink$.subscribe(setDownloadLink);
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container className={classes.container} component="main">
      {isLoading ? (
        <>
          <Grid item>
            <Typography>Getting link, please wait ...</Typography>
          </Grid>
          <Grid item className={classes.item}>
            <LinearProgress style={{ height: '2px', width: '50%' }} />
          </Grid>
        </>
      ) : null}
      {!isLoading && downloadLink ? (
        <>
          <Grid item className={classes.item}>
            <DoneIcon style={{ color: 'green', paddingRight: 5 }} />
            <Typography>
              Click <Link href={downloadLink}>{' here '}</Link> to download the Study
            </Typography>
          </Grid>
        </>
      ) : null}
      {!isLoading && !downloadLink ? (
        <>
          <Grid item className={classes.item}>
            <ErrorIcon style={{ color: 'red', paddingRight: 5 }} />
            <Typography>Cannot get download link</Typography>
          </Grid>
        </>
      ) : null}
    </Grid>
  );
};
